import { FC, FormEvent } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

import { FontFamilyBold, FontFamilyRegular } from "../../../constants";

// Define Interface
type Props = {
  className?: string;
  errorMessage?: string;
  title?: string;
  name?: string;
  type?: string;
  placeholder?: string;
  value?: string;
  readonly?: boolean;
  onChange?: (e: FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

interface CustomInputCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
  marginBottom?: string;
}

const CustomInputComp = styled.div<CustomInputCompProps>`
  width: 100%;
  margin-bottom: ${props => props.marginBottom};
  .title{
    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #242424;
    margin-bottom: 8px;
  }
  input, textarea{
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    border: solid 1px #ebebeb;
    background-color: #fff;

    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #242424;

    &::placeholder {
    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #bebebe;
  }
    &:focus-visible{
      outline: 0;
    }
  }
  
  .error-message{
    color: #ea4c60;
    font-family: ${props => props.fontFamilyRegular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    margin-bottom: 0;
    margin-top: 8px;
  }

  textarea{
    height: 96px;
  }
`
CustomInputComp.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular,
  marginBottom: "16px"
}

const CustomInput: FC<Props> = ({
  type,
  errorMessage,
  title,
  value,
  placeholder,
  className,
  readonly,
  name,
  onChange
}) => {
  return (
    <CustomInputComp className={className}>
      <p className="title">{title}</p>
      {
        type === "textarea" ?
          <textarea name={name} value={value} placeholder={placeholder} onChange={onChange} />
          :
          <input name={name} value={value} type={type} readOnly={readonly} onChange={onChange} placeholder={placeholder} />
      }

      {errorMessage ? <p className="error-message">{errorMessage}</p> : null}
    </CustomInputComp>
  )
}
CustomInput.defaultProps = {
  errorMessage: "",
  type: "text",
  title: "",
  placeholder: "",
  name: "",
  className: "",
  readonly: false,
  onChange: (e) => { }
}

export default CustomInput